import React, { useEffect } from "react";
import { getCommunityAdministrators } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const AdministratorsCommunities = ({ getCommunityAdministrators, communityAdministrators, period }) => {
  useEffect(() => {
    getCommunityAdministrators({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityAdministrators(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityAdministrators(payload);
  };

  return (
    <DataTable
      preset="administratorsCommunities"
      data={{
        docs: communityAdministrators?.docs || [],
        totalPages: communityAdministrators?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityAdministrators: state.appCommunities.communityAdministrators,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityAdministrators: (payload) => dispatch(getCommunityAdministrators(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministratorsCommunities);
